export default __webpack_public_path__ + "static/media/SH_FI.2c36f625.png";